export default {
    status: '',
    token: '',
    user : {},
    userAFM: '',
    role: '',
    isTaxisChecked: false,
    notAdmin: false,
}